import templateContainer from "../../containers/template";
import Templates from "./Templates";

export default templateContainer(Templates);
